module.exports = __webpack_public_path__ + "img/login-logo.e15712d4.png";